import { appRoutes } from '@/constants/routes';

export type SettingsNavItem = {
  id: string;
  label: string;
  icon: string;
  to?: string;
  comingSoon?: boolean;
  isNew?: boolean;
};

export type SettingsNavSection = {
  id: string;
  label: string;
  items: SettingsNavItem[];
};

export const settingsNavSections: SettingsNavSection[] = [
  {
    id: 'account',
    label: 'Account',
    items: [
      {
        id: 'personalization',
        label: 'Personalization',
        icon: 'puzzle',
        to: appRoutes.settingsPersonalization,
      },
      {
        id: 'knowledge-base',
        label: 'Knowledge base',
        icon: 'book-open-02',
        comingSoon: true,
      },
      {
        id: 'security',
        label: 'Security',
        icon: 'shield-01',
        comingSoon: true,
      },
    ],
  },
  {
    id: 'workspace',
    label: 'Workspace',
    items: [
      {
        id: 'general',
        label: 'General',
        icon: 'settings-01',
        comingSoon: true,
      },
      {
        id: 'usage',
        label: 'Usage',
        icon: 'limitation',
        comingSoon: true,
      },
      {
        id: 'billing',
        label: 'Subscription & Billing',
        icon: 'credit-card',
        to: appRoutes.settingsBilling,
        isNew: true,
      },
    ],
  },
];
